import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Sidebar } from "@/components/sidebar";
import { Dropdown } from "@/components/sidebar/Dropdown";

const ZOOM_LEVELS = [25, 50, 75, 100, 125, 150, 200, 300, 400];

type Props = {
  value: number;
  onChange: (value: number) => void;
};

export const GraphZoom = observer(function GraphZoom({ value, onChange = () => {} }: Props) {
  const t = useTranslations("sidebar.activeNode");

  const items = ZOOM_LEVELS.map((level) => ({
    title: `${level}%`,
    active: value === level,
    onClick: () => onChange(level),
  }));

  const activeItem = items.find((item) => item.active);

  return (
    <Dropdown
      toggleButtonComponent={
        <Sidebar.ToggleButton
          as="div"
          title={activeItem ? activeItem.title : "100%"}
          tooltipTitle={t("graph.actions.graphZoom")}
          className="min-h-[33px] bg-input-bg shadow-block dark:shadow-block-inverted"
        />
      }
      items={items}
      itemsClassName="min-w-[120px]"
    />
  );
});
